export default "__VITE_ASSET__8BDoZUCW__"